import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {IconButton, Button, Tooltip, makeStyles} from "@material-ui/core";
import ClearSharpIcon from '@material-ui/icons/ClearSharp';
import {uid} from 'react-uid';
import Actions from "../../Actions/Actions";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import Fields from "../../../ToolBarUtils/Fields/Fields";

const grayBorder = '1px solid rgba(0, 0, 0, 0.12)';
const useStyles = makeStyles(() => ({
    eventWrapper: {
        display: 'flex',
        width: '100%',
        '& $option': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $option': {
                visibility: 'visible'
            }
        }
    },
    optionBtn: {
        padding: 0,
        left: -20
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        width: 0
    },
    paramActionLine: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 2,
        cursor: 'pointer',
        borderLeft: grayBorder,
        borderRight: grayBorder,
        borderBottom: grayBorder,
        transition: 'all 0.2s ease',
        '& span': {
            display: 'none'
        },
        '&:hover': {
            height: 12,
            background: 'transparent',
            borderTop: grayBorder,
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: grayBorder,
            transition: 'all 0.2s ease',
            '& span': {
                display: 'block',
                color: 'rgba(0, 0, 0, 0.42)'
            }
        }
    },
    btnLabel: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}));

const EventsForm = ({schema}) => {
    const {
        selectedComponent: {component: {_isLocked, events = [{actions: []}]} = {}},
        createEvent,
        removeEvent,
        onChangeEventComponent
    } = useContext(ScreenDesignerContextNew);
    const classes = useStyles();
    const [actionOpen, setActionOpen] = useState(false);
    const [eventIndexOpened, setEventIndexOpened] = useState(null);
    const onKeyDown = (e, index) => {
        if (e.ctrlKey && e.shiftKey && e.key === 'Insert') {
            createEvent(index);
            return;
        }
        if (e.ctrlKey && e.key === 'Insert') {
            createEvent(index + 1);
            return;
        }
        if (e.ctrlKey && e.key === 'Delete') {
            removeEvent(index)
        }
    };
    const openActions = (index) => {
        setEventIndexOpened(index);
        setActionOpen(true);
    };
    const closeEvents = () => {
        setActionOpen(false);
        setEventIndexOpened(null)
    };
    if (!Array.isArray(events)) return <></>
    return (
        <>
            {events.map((event, index) => {
                const actions = (events[index].actions || []).map(a => {
                    const source = schema.actions || [];
                    let findSourceIndex = source.findIndex(f => f.value === a.type)
                    return findSourceIndex !== -1 ? schema.actions[findSourceIndex].label : a.type
                });
                return (
                    <React.Fragment key={uid(`${event.event}_${index}`)}>
                        {index === 0 && (
                            <div className={classes.paramActionLine}
                                 onClick={() => createEvent(index)}>
                                <span>+</span>
                            </div>
                        )}
                        <div
                            className={classes.eventWrapper}
                            onKeyDown={(e) => onKeyDown(e, index)}
                        >
                            <div style={{width: '50%'}}>
                                <Fields
                                    field={{type: 'select', menu: schema.events, disabled: _isLocked}}
                                    path={`${index}.event`}
                                    values={events}
                                    onChange={onChangeEventComponent}
                                />
                            </div>
                            <div style={{width: '50%'}}>
                                <Button
                                    classes={{label: classes.btnLabel}}
                                    disalbed={_isLocked}
                                    variant={"text"}
                                    style={{
                                        width: '100%',
                                        padding: '0',
                                        height: 27,
                                        textAlign: 'left',
                                        display: 'block',
                                        fontSize: 16,
                                        whiteSpace: 'nowrap',
                                    }}
                                    onClick={() => _isLocked ? {} : openActions(index)}>

                                    {actions.length ? (
                                        actions.join(', ')
                                    ) : (
                                        'Create New Action'
                                    )}

                                </Button>
                            </div>
                            <RemoveEvent
                                removeEvent={removeEvent}
                                index={index}
                                event={event}
                                eventsLength={events ? events.length : 0}
                            />
                        </div>
                        <div className={classes.paramActionLine}
                             onClick={() => createEvent(index + 1)}>
                            <span>+</span>
                        </div>
                    </React.Fragment>
                )
            })}
            <Actions
                open={actionOpen}
                onClose={closeEvents}
                eventIndex={eventIndexOpened}
                schema={schema.actions}
                onChangeEventComponent={onChangeEventComponent}
            />
        </>
    )
};
export default EventsForm

EventsForm.propTypes = {
    schema: PropTypes.object,
    createEvent: PropTypes.func,
    removeEvent: PropTypes.func,
    selectedComponent: PropTypes.object
};
EventsForm.defaultProps = {
    schema: {}
};

const RemoveEvent = ({event, index, removeEvent, eventsLength}) => {
    const classes = useStyles();
    let btn = <div className={classes.option}>
        <Tooltip title={'Remove Event'}>
            <IconButton className={classes.optionBtn} onClick={() => {
                removeEvent(index)
            }}>
                <ClearSharpIcon fontSize={"small"}/>
            </IconButton>
        </Tooltip>
    </div>;

    if (index === 0) {
        if (event.event || eventsLength > 1) {
            return btn
        } else {
            return <></>
        }
    } else {
        return btn
    }
};